import { FC, ReactElement } from 'react';

import { DefaultHelmet } from '../../../../compositions';
import { AppRoute, appRoutes } from '../../../../entities/Routing/Routing';
import { useTrans } from '../../../../hooks';

interface SearchPageHelmetProps {
    query: string;
}

export const SearchPageHelmet: FC<SearchPageHelmetProps> = ({ query }): ReactElement => {
    const trans = useTrans();

    const siteUrl = trans('company.url');

    const title = query
        ? trans('pages.search.meta.queryTitle', { query })
        : trans('pages.search.meta.title');

    return (
        <DefaultHelmet
            title={title}
            description={trans('pages.search.meta.description')}
            canonical={siteUrl + trans(appRoutes[AppRoute.search].path)}
        />
    );
};
